import React from "react";
import { useLocation } from "react-router";
import { useMailContext } from "../../context/MailContext";
import { MailView } from "../MailView";
import { dvagOrdnerAusKey } from "../../services/dvagPostService";
import { DvagPostView } from "./DvagPostView";

/**
 * Inhalt von `/emails`: die Mail-Ansicht oder, wenn im Mail-Menü ein Ordner
 * der Kontakt- oder Schadenhistorie gewählt ist, die DVAG-Ansicht.
 *
 * Die Weiche liegt VOR der Mail-Ansicht und nicht in ihr: `MailView` lädt für
 * jeden gewählten Ordner aus Outlook — ein Ordner, den es dort nicht gibt,
 * liefe in einen Graph-404.
 */
export const SchriftverkehrAnsicht: React.FC = () => {
    const { activeFolder } = useMailContext();
    const location = useLocation();
    const dvag = dvagOrdnerAusKey(activeFolder?.id);
    // Ein Link auf eine bestimmte Mail (`/emails?…`) meint immer die Mail-Ansicht.
    if (dvag && !location.search) return <DvagPostView bereich={dvag.bereich} ordner={dvag.ordner} />;
    return <MailView />;
};
